module.exports = __webpack_public_path__ + "static/media/CambioCoba.f8ffe108.pdf";